import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLSourceElement extends HTMLElement { constructor(tagName: string = 'SOURCE', ownerDocument?: any) { super(tagName, ownerDocument); } }
